import React from 'react'

import DashboardWrapper from '../../dashboard/DashboardWrapper'
import PDFExport from '../../dashboard/charts/PDFExport'
import Charts from './index'

const ChartsExport = () => {
    return (
        <PDFExport downloadKey="success-rate-pdf" fileName="SuccessRate_Charts.pdf">
            <DashboardWrapper>
                <iv className="report-container">
                    <Charts />
                </iv>
            </DashboardWrapper>
        </PDFExport>
    )
}

export default ChartsExport